import router from '@/router/index.js'

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token')
  if (to.path === '/') {
    next()
  } else {
    if (token) {
      next()
    } else {
      next('/')
    }
  }
})
